export function initEventSlider($) {
	$('.event-slider').each(function(n, el) {
		$('.owl-carousel', el).owlCarousel({
			items: 4,
			loop: true,
			nav: true,
			navText: [
				'<i class="fal fa-chevron-left"></i>',
				'<i class="fal fa-chevron-right"></i>'
			],
			dots: false,
			autoplay: false,
			autoplayTimeout: 5000,
			margin: 30,
			smartSpeed: 750,

			responsive: {
				0: {
					items: 1
				},
				640: {
					items: 2
				},
				1024: {
					items: 3
				},
				1200: {
					items: 4
				}
			}
		});
	});
}